import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";

import { Select } from "../../../inputs";

const PrefilledListOrder = ({ value, onChange }) => {
  const { t } = useTranslation();

  return (
    <Select value={value} onChange={onChange}>
      <Select.Option value="All">{t("All")}</Select.Option>
      <Select.Option value="All, Matched">{t("All, Matched")}</Select.Option>
      <Select.Option value="All, Mutual">{t("All, Mutual")}</Select.Option>
      <Select.Option value="All, Mutual, Matched">{t("All, Mutual, Matched")}</Select.Option>
      <Select.Option value="All, Matched, Mutual">{t("All, Matched, Mutual")}</Select.Option>
      <Select.Option value="Mutual">{t("Mutual")}</Select.Option>
      <Select.Option value="Mutual, All">{t("Mutual, All")}</Select.Option>
      <Select.Option value="Mutual, Matched">{t("Mutual, Matched")}</Select.Option>
      <Select.Option value="Mutual, All, Matched">{t("Mutual, All, Matched")}</Select.Option>
      <Select.Option value="Mutual, Matched, All">{t("Mutual, Matched, All")}</Select.Option>
    </Select>
  );
};

PrefilledListOrder.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
};

PrefilledListOrder.defaultProps = {
  value: undefined,
  onChange: () => undefined,
};

export default PrefilledListOrder;
